import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { BASE_URL_STATIC } from '../../../../config';
import { ApiContext } from '../../UseContext/ApiCall';
import { settingContext } from '../../UseContext/SettingContext';


const CnpAdvanceSettingPopup = () => {

  const {
    handleCnpOpenPreviousPopup,

    showCnpAdvanceSettingPopup, setShowCnpAdvanceSettingPopup,
    cnpMainSetting,
    cnpAdvanceSetting, setCnpAdvanceSetting,
  } = useContext(ApiContext);

  
  const { 
    isAccountPrivate
  } = useContext(settingContext);

  
  // handle option change
  const handleOptionChange = (e) => {
    const { name, value } = e.target;

    // console.log(name, value);

    if(name === 'view') {
      setCnpAdvanceSetting(prev => ({
        ...prev,
        view: value,
        comment: value,
      }));  
    } else {
      setCnpAdvanceSetting(prev => ({
        ...prev,
        [name]: value,
      }));
    };
  };

  // handle close photo video advance setting popup
  const handleClosePhotoVideoAdvanceSettingPopup = () => {
    setShowCnpAdvanceSettingPopup(false);
    handleCnpOpenPreviousPopup();
  };

  // Messages to show according to option
  const message = {
    public: 'Everyone on EMILO can',
    fof: 'Your followers & as well as their followers can',
    followers: 'Only your followers can',
    listOne: 'Only your close friends (list one) can',
    listTwo: 'Only your close friends (list two) can',
    none: 'No one can',
  };


  return (
    <>
      <Modal show={showCnpAdvanceSettingPopup} onHide={handleClosePhotoVideoAdvanceSettingPopup} centered backdrop="static" keyboard={false} className="main-modal" >
      {/* <Modal show={true} onHide={handleClosePhotoVideoAdvanceSettingPopup} centered backdrop="static" keyboard={false} className="main-modal" > */}
        <Modal.Header className='mb-3 pt-0' closeButton>
          <h5 className='flex-grow-1 text-center pt-3 mb-0'>Advance Setting</h5>
        </Modal.Header>

        <Modal.Body className='pt-1'>
          <>
            {
              cnpAdvanceSetting
              &&
              <section className='border overflow-y-scroll p-2' style={{ height: '50vh' }}>
                {/* Audience Control */}
                <div className='my-3'>
                  <div className='accordion-level-3 shadow-sm accordion-button pe-3 pe-xl-4 ps-3 py-2' data-bs-toggle="collapse" data-bs-target="#post-audienceControl">
                    <img src={`${BASE_URL_STATIC}/icon/audience-control.svg`} alt="audience-control" />
                    <h5 className='fw-semibold ms-3'>Audience Control</h5>
                  </div>

                  <div id='post-audienceControl' className="accordion-collapse collapse show accordion accordion-flush my-0">
                    {/* View */}
                    <div className='ms-3 mt-3'>
                      <h5 className='accordion-level-4 shadow-sm' data-bs-toggle="collapse" data-bs-target="#audienceControlView">Who can view?</h5>

                      <div id='audienceControlView' className='row accordion-collapse collapse show mt-3 ms-3 me-0'> 
                        {/* Value */}
                        <div className='row'>
                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-view-public" name="view" value='public' 
                              checked={!cnpAdvanceSetting.view || cnpAdvanceSetting.view === 'public'} 
                              disabled={cnpMainSetting.view === 'fof' || cnpMainSetting.view === 'followers' || cnpMainSetting.view === 'listOne' || cnpMainSetting.view === 'listTwo'}
                              onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-view-public">Public</label>
                          </div>

                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-view-fof" name="view" value='fof' 
                              checked={cnpAdvanceSetting.view === 'fof'} 
                              disabled={isAccountPrivate === 'public' && (cnpMainSetting.view === 'followers' || cnpMainSetting.view === 'listOne' || cnpMainSetting.view === 'listTwo')}
                              onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-view-fof">Followers of Followers</label>
                          </div>

                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-view-followers" name="view" value='followers' 
                              checked={cnpAdvanceSetting.view === 'followers'} 
                              disabled={cnpMainSetting.view === 'listOne' || cnpMainSetting.view === 'listTwo'}
                              onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-view-followers">Followers</label>
                          </div>

                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-view-cf-lo" name="view" value='listOne' 
                              checked={cnpAdvanceSetting.view === 'listOne'} onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-view-cf-lo">Close Friends (List One)</label>
                          </div>

                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-view-cf-lt" name="view" value='listTwo' 
                              checked={cnpAdvanceSetting.view === 'listTwo'} onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-view-cf-lt">Close Friends (List Two)</label>
                          </div>

                          <small className='pt-1 text-secondary ms-2 mb-3'>({message[cnpAdvanceSetting.view ? cnpAdvanceSetting.view : 'public']} view your post)</small>
                        </div>

                        <hr className='hr bg-secondary mt-3' style={{ width: '-webkit-fill-available' }} />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Likes & Comments */}
                <div className='my-3'>
                  <div className='accordion-level-3 shadow-sm accordion-button pe-3 pe-xl-4 ps-3 py-2' data-bs-toggle="collapse" data-bs-target="#post-likeAndComments">
                    <img src={`${BASE_URL_STATIC}/icon/like-comment.svg`} alt="like-comment" />
                    <h5 className='fw-semibold ms-3'>Likes & Comments</h5>
                  </div>

                  <div id='post-likeAndComments' className="accordion-collapse collapse show accordion accordion-flush my-0">
                    {/* Like Count */}
                    <div className='ms-3 mt-3 me-auto'>
                      <div className='d-flex justify-content-between align-items-center my-2'>
                        <h5 className='accordion-level-4 shadow-sm'>Hide like count</h5>

                        <div className="form-check form-switch m-0">
                          <input type="checkbox" className="form-check-input" role="switch" aria-checked name='like' 
                            value={cnpAdvanceSetting.like === 'true' ? false : true}
                            checked={cnpAdvanceSetting.like === 'true' ? true : false} 
                            onChange={handleOptionChange} 
                          />
                        </div>
                      </div>

                      <small className='text-secondary d-block ms-3 mt-2'>(Confirm if you want to hide the like counts of your post)</small>
                    </div>

                    <hr className='hr bg-secondary ms-3' style={{ width: '-webkit-fill-available' }} />

                    {/* Comments */}
                    <div className='ms-3'>
                      <h5 className='accordion-level-4 shadow-sm' data-bs-toggle="collapse" data-bs-target="#likeAndCommentsComment">Who can comment?</h5>

                      <div id='likeAndCommentsComment' className='row accordion-collapse collapse show mt-3 ms-3 me-0'> 
                        {/* Value */}
                        <div className='row'>
                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-comment-public" name="comment" value='public' 
                              checked={cnpAdvanceSetting.comment === 'public'} 
                              disabled={cnpAdvanceSetting.view === 'fof' || cnpAdvanceSetting.view === 'followers' || cnpAdvanceSetting.view === 'listOne' || cnpAdvanceSetting.view === 'listTwo'}
                              onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-comment-public">Public</label>
                          </div>

                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-comment-fof" name="comment" value='fof' 
                              checked={cnpAdvanceSetting.comment === 'fof'}
                              disabled={cnpAdvanceSetting.view === 'followers' || cnpAdvanceSetting.view === 'listOne' || cnpAdvanceSetting.view === 'listTwo'}
                              onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-comment-fof">Followers of Followers</label>
                          </div>

                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-comment-followers" name="comment" value='followers' 
                              checked={cnpAdvanceSetting.comment === 'followers'}
                              disabled={cnpAdvanceSetting.view === 'listOne' || cnpAdvanceSetting.view === 'listTwo'}
                              onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-comment-followers">Followers</label>
                          </div>

                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-comment-cf-lo" name="comment" value='listOne' 
                              checked={cnpAdvanceSetting.comment === 'listOne'} 
                              disabled={cnpAdvanceSetting.comment === 'listTwo'}
                              onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-comment-cf-lo">Close Friends (List One)</label>
                          </div>

                          <div className="ms-2 mb-1 col-lg-5">
                            <input className="form-check-input" type="radio" id="ps-comment-cf-lt" name="comment" value='listTwo' 
                              checked={cnpAdvanceSetting.comment === 'listTwo'} 
                              disabled={cnpAdvanceSetting.comment === 'listOne'}
                              onChange={handleOptionChange} 
                            />
                            <label className="form-check-label" htmlFor="ps-comment-cf-lt">Close Friends (List Two)</label>
                          </div>

                          <small className='pt-1 text-secondary ms-2 mb-3'>({message[cnpAdvanceSetting.comment ? cnpAdvanceSetting.comment : 'public']} comment on your post.)</small>
                        </div>

                        <hr className='hr bg-secondary' style={{ width: '-webkit-fill-available' }} />
                      </div>
                    </div>
                  </div>
                </div>

              </section>
            }
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CnpAdvanceSettingPopup;